import React, {memo} from 'react';
import { animated, useSpring } from 'react-spring';
import AboutImg from "../img/icons/about-icon-small.webp";
import Headshot from './Headshot';

function AboutSection() {
  const sp1 = useSpring({
    opacity: 1,
    transform: "translateY(0px)",
    from: { opacity: 0 }, /*, transform: "translateY(-20px)" },*/
    delay: 100
  });

  return (
    <animated.section style={sp1} id="about-section" aria-label="About me">
      <Headshot/>
      <div className='about-sec-right-container'>
        {/*<div className='section-header'>
          <div id="about-header">
            <h1>About me</h1>
            <img src={AboutImg} alt={"simple line art of a person's outline"}/>
          </div>
          <div className="border-scribble"></div>
        </div>*/}
        <article>
          <p>
            I'm a CS PhD student in Northeastern's <a href="https://vis.khoury.northeastern.edu/" target="_blank" rel="noreferrer">Data Visualization Lab</a>,
            advised by <a href="https://www.lacepadilla.com/" target="_blank" rel="noreferrer">Lace Padilla</a>.
            I have a wide variety of interests including visualization, accessibility, and mechanistic interpretability.
            I also enjoy rock climbing, making art, and hanging out with my cats.
            {/*Previously I was a master's student in computer science at the University of Washington,
            and a member of the <a href="https://noahs-ark.github.io/" target="_blank" rel="noreferrer">ARK NLP group</a>.*/}
          </p>
          {/*<h2>Thank you to my past mentors:</h2>
          <ul>
            <li><a href="https://suchin.io/" target="_blank" rel="noreferrer">Suchin Gururangan</a></li>
            <li><a href="https://people.csail.mit.edu/cloudygoose/" target="_blank" rel="noreferrer">Tianxing He</a></li>
            <li><a href="https://danbirman.com/" target="_blank" rel="noreferrer">Dan Birman</a></li>
            <li><a href="https://sites.google.com/view/paige-helms" target="_blank" rel="noreferrer">Paige Helms</a></li>
          </ul>*/}
        </article>
      </div>
    </animated.section>
  );
}

export default memo(AboutSection);